import React from 'react';
import PropTypes from 'prop-types';
import Text from 'components/shared/Text';
import styles from './styles.module.scss';

function FieldsSeparator({ styles: customStyles, children, ...props }) {
  return (
    <Text muted styles={[styles.fieldsSeparator, ...customStyles]} {...props}>
      {children}
    </Text>
  );
}

FieldsSeparator.propTypes = {
  children: PropTypes.any,
  styles: PropTypes.array
};

FieldsSeparator.defaultProps = {
  children: null,
  styles: []
};

export default FieldsSeparator;
